import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Home from "./pages/Home/Home";
import Prizes from "./pages/Prizes/Prizes";
import Howtoplay from "./pages/Howtoplay/Howtoplay";
import Play from "./pages/Play/Play";
import Test from "./pages/Test";
import MyWinnings from "./pages/MyWinnings/MyWinnings";
import Page404 from "./pages/Error/Page404";
import ContactUs from "./pages/Others/ContactUs";

export const PlayContext = React.createContext();

function App() {
  const [open, setOpen] = useState(true);

  const toggleOpen = () => {
    console.log("opening up again");
    setOpen(!open);
  };

  return (
    <PlayContext.Provider value={{ open, toggleOpen }}>
      <Router>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/prizes" exact component={Prizes} />
          <Route path="/how-to-play" exact component={Howtoplay} />
          <Route path="/play" exact component={Play} />
          <Route path="/my-winnings" exact component={MyWinnings} />
          <Route path="/contact-us" exact component={ContactUs} />
          <Route component={Page404} />
        </Switch>
      </Router>
    </PlayContext.Provider>
  );
}

export default App;
